(function () {
    const overlay = document.querySelector('.hero-emblem-overlay');
    if (!overlay) return;
    const hero = document.querySelector('.wp-block-cover.sar61-hero');
    if (!hero) return;

    let visible = null; // memoize state to avoid redundant class flips
    let ticking = false; // rAF throttle

    function compute() {
        const heroRect = hero.getBoundingClientRect();
        const emblemRect = overlay.getBoundingClientRect();

        // Positive gap means emblem bottom is above hero bottom.
        const gap = heroRect.bottom - emblemRect.bottom;

        // Hero visible at all?
        const heroOnScreen = heroRect.bottom > 0 && heroRect.top < window.innerHeight;

        // Start fading when we are within this many pixels of the hero bottom
        const FADE_START_GAP = 0; // px

        // Visible while the gap is still larger than our fade-start gap
        const shouldShow = heroOnScreen && gap > FADE_START_GAP;

        if (visible !== shouldShow) {
            overlay.classList.toggle('is-active', shouldShow);
            visible = shouldShow;
        }
    }

    function update() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
            ticking = false;
            compute();
        });
    }

    // Bind
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('DOMContentLoaded', update);
    window.addEventListener('load', update);
    update();
})();

(function () {
    const tracks = document.querySelectorAll('.sar61-gt__track');
    tracks.forEach(track => {
        const dots = track.parentElement.querySelectorAll('.sar61-gt__dot');
        if (!dots.length) return;

        function updateActive() {
            const idx = Math.round(track.scrollLeft / track.clientWidth);
            dots.forEach((dot, i) => dot.classList.toggle('is-active', i === idx));
        }

        track.addEventListener('scroll', updateActive, { passive: true });
        window.addEventListener('resize', updateActive);
        updateActive();
    });
})();
